module.exports = __webpack_public_path__ + "static/people@2x-d9cd5978d5b764d1120abf210590e5fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/agencies-industry-pages/people@2x.jpg
// module id = 2531
// module chunks = 281026976107462